import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import InputFieldComponent from './InputFieldComponent';

/**
 * The format of the date return will be 'yyyy-mm-dd', default format défine by HTML5
 */
class HourInputFieldComponent extends React.Component {
    render() {
        return <InputFieldComponent {...this.props} type="time" />;
    }
}

// See proptypes in ./InputFieldComponent.js for global Field props
HourInputFieldComponent.propTypes = {
    mustBeDateFuture: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18nFeatureForm: state.i18n.feature.form
    };
};

export default connect(mapStateToProps)(HourInputFieldComponent);



// WEBPACK FOOTER //
// ./src/components/form/HourInputFieldComponent.js